import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import PagePrivacyPolicy, { path as PagePrivacyPolicyPath } from 'pages/PagePrivacyPolicy';
import MuiTheme from './theme';

/**
 * Дерево приложения для страниц, открытых без авторизации.
 *
 * Намеренно минимально: сюда не входят SessionProvider (Keycloak), Redux, AppBar
 * и глобальные виджеты уведомлений — иначе анонимный пользователь получал бы 401,
 * а перехватчик в api.ts уводил бы его на страницу входа.
 *
 * Новый публичный маршрут добавляется здесь и в PUBLIC_ROUTES (publicRoutes.ts).
 */
const PublicApp: React.FC = () => (
  <MuiTheme>
    <BrowserRouter>
      <Switch>
        <Route component={PagePrivacyPolicy} exact path={PagePrivacyPolicyPath} />
      </Switch>
    </BrowserRouter>
  </MuiTheme>
);

export default PublicApp;
